import React from 'react';
import autobind from "autobind-decorator";
import { Link } from 'core/components/Framework7';

import { PureComponent } from 'core/components';

class Advertise extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      
    }
  }

  static get defaultProps() {
    return {
      Image: "",
      height: "8rem",
      link: ""
    }
  }

  render() {
    const { image, height, link } = this.props

    return (
      <Link href={link}>
        <img alt="advertice" src={image} style={{height: height, width: "100%", margin: 16}} />
      </Link>
    )
  }
}

export default autobind(Advertise);
